// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const MenuLabel = createStyle({});
